import { useProductPageStore } from '../../contexts/ProductPageStore'
import groupBy from '../../utils/groupBy'
import styles from './garageSaleDrawer.module.scss'

import React, { useContext, useEffect, useState } from 'react'

import { useUserStore } from 'Clutch/Stores/UserStore/UserStore'
import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'
import Image from 'next/image'

import { getSuperMarketAffinity } from 'Clutch/Utilities/Instrumentation/SegmentUtilities/segmentFunctions'

import { TrackingContext } from 'Clutch/Contexts/TrackingContext/TrackingContext'

import Drawer from 'Clutch/Molecules/Drawer'

import Divider from 'Clutch/Atoms/Divider'
import TextLink from 'Clutch/Atoms/TextLink'
import Typography from 'Clutch/Atoms/Typography'

const GarageSaleDrawer = ({}) => {
  const userGuid = useUserStore((x) => x.context.userGuid)
  const userVin = useUserStore((x) => x.context.userVin)
  const isGarageSaleDrawerOpen = useProductPageStore((x) => x.isGarageSaleDrawerOpen)
  const garageSaleSkuVariants = useProductPageStore((x) => x.garageSaleSkuVariants)
  const segmentCategorization = useProductPageStore((x) => x.segmentCategorization)
  const brand = useProductPageStore((x) => x.brand)
  const hideGarageSaleDrawer = useProductPageStore((x) => x.hideGarageSaleDrawer)

  const { segmentReady } = useContext(TrackingContext)

  const [segmentEventFired, setSegmentEventFired] = useState(false)

  const title = 'Garage Sale Alternatives'

  useEffect(() => {
    if (isGarageSaleDrawerOpen && !segmentEventFired) {
      //send segment product list viewed
      //this feeds miso recommendation impressions
      if (segmentReady && (garageSaleSkuVariants || []).length > 0) {
        try {
          analytics.track('Product List Viewed', {
            user_vin: `${userVin()}`,
            web_user_guid: `${userGuid}`,
            list_id: `pdp_drawer_garageSale`,
            category: `${title}`,
            products: (garageSaleSkuVariants || []).map((garageSaleSku, i) => {
              return {
                product_id: garageSaleSku.skuBaseNumber,
                sku: garageSaleSku.skuVariantNumber,
                name: garageSaleSku.displayTitle,
                price: garageSaleSku.price,
                position: i,
                category: segmentCategorization,
                url: garageSaleSku.productPageUrl,
                image_url: garageSaleSku.imageUrl,
                quantity: 1,
                brand: brand ? brand.brandName || '' : '',
                availability: garageSaleSku.availability,
                rating: garageSaleSku.reviewCount ? garageSaleSku.rating : 0,
                reviews: garageSaleSku.reviewCount,
                audience_affinity: getSuperMarketAffinity(garageSaleSku),
              }
            }),
          })
        } catch (err) {
          console.error(err)
        }

        setSegmentEventFired(true)
      } else {
        console.info('analytics not defined')
      }
    }
  }, [isGarageSaleDrawerOpen, segmentReady])

  const groupedGarageSaleSkuVaraints = groupBy(garageSaleSkuVariants || [], 'garageSaleType')

  return (
    <Drawer location={'right'} width={640} open={!!isGarageSaleDrawerOpen} closeFunction={() => hideGarageSaleDrawer()}>
      <div className={styles.garage_sale_container}>
        <Typography size={1.25} font={'heading'}>
          {title}
        </Typography>
        <Divider className={styles.divider} />

        {Object.values(groupedGarageSaleSkuVaraints).map((garageSaleSkuVariantGroup, i) => (
          <ErrorBoundary key={`gs-group-${i}`}>
            <Typography size={0.875} font={'bold'} className={styles.garage_sale_type}>
              {(garageSaleSkuVariantGroup || []).length && garageSaleSkuVariantGroup[0].garageSaleType
                ? `${garageSaleSkuVariantGroup[0].garageSaleType}:`
                : 'Other:'}
            </Typography>

            {(garageSaleSkuVariantGroup || []).map((garageSaleSkuVariant, j) => (
              <ErrorBoundary key={`gs-variant-${i}-${j}`}>
                <div className={styles.rec_wrapper}>
                  {/* Left Side */}
                  <span className={styles.rec_image_wrapper}>
                    <TextLink href={garageSaleSkuVariant.productPageUrl}>
                      <Image
                        height={64}
                        width={64}
                        src={
                          garageSaleSkuVariant.imageUrl
                            ? `https:${garageSaleSkuVariant.imageUrl}`
                            : 'https://content.speedwaymotors.com/OtherImages/missingimage2.jpg'
                        }
                      />
                    </TextLink>
                  </span>
                  {/* Right Side */}
                  <span>
                    <TextLink href={garageSaleSkuVariant.productPageUrl} size={0.875}>
                      {garageSaleSkuVariant.displayTitle}
                    </TextLink>
                    <Typography size={1} font={'bold'}>
                      {garageSaleSkuVariant.priceString}
                    </Typography>
                  </span>
                </div>
                {j !== garageSaleSkuVariants.length - 1 ? <Divider className={styles.divider} /> : false}
              </ErrorBoundary>
            ))}
          </ErrorBoundary>
        ))}
      </div>
    </Drawer>
  )
}

export default GarageSaleDrawer
